import React from 'react';
import './Footer.css';

const Footer = props => {
    return (
        <div className="footer">
            <span className="copyright">
               kd © 2026 (v0.1-Beta)
            </span>
        </div>

    );
};

export default Footer;